import { savedSearchActionTypes as actionType } from 'src/constants/actionTypes';
import savedSearchService from 'src/services/savedSearchService';
import dispatchError from 'src/utils/dispatchError';

export function saveSearch(data) {
  return async (dispatch) => {
    try {
      const savedSearchRes = await savedSearchService.saveSearch(data);
      const payload = {
        ...savedSearchRes,
        query: data.query || []
      };

      dispatch({
        type: actionType.SAVE_SUCCESS,
        payload: {
          savedSearch: payload,
          successMsg: 'Your search was saved'
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to save the search');
    }
  };
}

export function getSavedSearches(data) {
  return async (dispatch) => {
    try {
      const savedSearchList = await savedSearchService.getSavedSearches(data);
      dispatch({
        type: actionType.GET_ALL_SUCCESS,
        payload: {
          savedSearchList
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to get saved searches');
    }
  };
}

export function deleteSavedSearch(searchId) {
  return async (dispatch) => {
    try {
      const savedSearchList = await savedSearchService.deleteSavedSearch(searchId);

      dispatch({
        type: actionType.DELETE_SUCCESS,
        payload: {
          id: savedSearchList.id
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to delete saved search');
    }
  };
}

export const removeMessage = () => ({ type: actionType.CLEAR_MESSAGES });
